import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container document-view" }
const _hoisted_2 = { class: "breadcrumb-voucher py-3" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item active" }
const _hoisted_8 = {
  class: "main gap-4",
  role: "main"
}
const _hoisted_9 = { class: "d-flex flex-column col-md-12 col-lg-6" }
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = { class: "doc-notes py-4 pt-0 px-3 rounded-3" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = {
  key: 0,
  class: "fs-7"
}
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "uploads w-100" }
const _hoisted_18 = { class: "d-flex justify-content-end action-section flex-row" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_FilesLoader = _resolveComponent("FilesLoader")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  color: "info",
                  name: "house"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: `/`,
              class: "color--info"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "Emissão de certificado", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "color--primary disabled fw-600"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Envio de arquivos ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "fw-600" }, "Agora vamos precisar de alguns documentos", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Você solicitou as alterações abaixo:", -1)),
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDocsPf, (docNote, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['far', 'circle-check'],
                class: "me-2 text-success"
              }),
              _createTextVNode(" " + _toDisplayString(docNote.title) + "; ", 1)
            ]))
          }), 128))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, " Para validar essas alterações, verifique o que você vai precisar enviar. ", -1)),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDocsPf, (docNote, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "pt-5"
            }, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(docNote.title) + ":", 1),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                (docNote.notes.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, " escolha uma das opções abaixo "))
                  : _createCommentVNode("", true)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docNote.notes, (note, index2) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index2,
                    class: "text-break mt-3"
                  }, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(note.title) + ": ", 1),
                    _createElementVNode("span", {
                      innerHTML: note.description
                    }, null, 8, _hoisted_16)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Upload, {
          class: "element-sticky",
          "is-mobile": _ctx.isMobile,
          "files-loaded": _ctx.filesLoaded,
          "extension-types": _ctx.extensionsAllows,
          onAddFile: _ctx.handleAddFile
        }, null, 8, ["is-mobile", "files-loaded", "extension-types", "onAddFile"]),
        _createVNode(_component_FilesLoader, {
          "files-loaded": _ctx.filesLoaded,
          "extension-types": _ctx.extensionsAllows,
          onHandleDeleteFile: _ctx.handleDeleteFile
        }, null, 8, ["files-loaded", "extension-types", "onHandleDeleteFile"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn", _ctx.isInvalid ? 'btn-secondary disabled' : 'btn-primary']),
        type: "button",
        disabled: _ctx.isInvalid,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendFiles && _ctx.sendFiles(...args)))
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
        _createVNode(_component_Icon, { name: "arrow-right" })
      ], 10, _hoisted_19)
    ]),
    _createVNode(_component_Contact, { style: {"margin-bottom":"6rem"} })
  ]))
}